var $6da0671a69d07deb$exports = {};
$6da0671a69d07deb$exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Valittu p\xe4iv\xe4m\xe4\xe4r\xe4 ei ole`,
            other: `Valitut p\xe4iv\xe4m\xe4\xe4r\xe4t eiv\xe4t ole`
        })} saatavilla.`
};


export {$6da0671a69d07deb$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
